export default __webpack_public_path__ + "static/media/qr-templated-gas97.d14779d7.png";